// extracted by mini-css-extract-plugin
export default {"center":"UserIdea_center__5k+QP","form":"UserIdea_form__5RZki","formInput":"UserIdea_formInput__TGvkX"};